import { z } from 'zod';
import i18n from '../i18n';

// ── Annulla (sopravvive al refactor: stesso payload server-side) ─────────────

export const annullaSchema = z.object({
  motivazione: z.string().min(3, i18n.t('richieste.annulla.val_min')),
});
export type AnnullaFormData = z.infer<typeof annullaSchema>;

// NB (Blocco 6 STEP 4 sotto-commit 3): la validazione di genera-preventivo-omologa
// e invia-cliente vive ora nei rispettivi componenti — GeneraPreventivoOmologaWizard
// (usa omologaCreateSchema per il ramo "nuova") e InviaClienteModal (valida inline la
// scelta allegati). I vecchi schemi zod qui, basati sui campi scheda omologa inline
// droppati dal BE, sono stati rimossi per non lasciare dead code fuorviante.

// ── Consultazione (#96) ─────────────────────────────────────────────────────

export const apriConsultazioneSchema = z.object({
  tipo: z.enum(['RT', 'DIR']),
  commento_richiesta: z.string().min(1, i18n.t('richieste.consultazione.val_commento')),
});
export type ApriConsultazioneFormData = z.infer<typeof apriConsultazioneSchema>;

export const rispondiConsultazioneSchema = z.object({
  commento_risposta: z.string().min(1, i18n.t('richieste.rispondi.val_obbligatoria')),
});
export type RispondiConsultazioneFormData = z.infer<typeof rispondiConsultazioneSchema>;
